export default __webpack_public_path__ + "static/media/DSC1.94dc1ad4.jpg";